import React from 'react';
import { FaExclamationTriangle } from 'react-icons/fa'; // Import an icon from react-icons
import { Popup } from '../Common/Popup/main';

interface AlertPopupProps {
  alertPopup: boolean;
  setAlertPopup: (value: boolean) => void;
  errMessage: string;
}

const AlertPopup: React.FC<AlertPopupProps> = ({ alertPopup, setAlertPopup, errMessage }) => {
  return (
    <>
      {alertPopup ? (
        <Popup onClose={()=>setAlertPopup(false)}>
                <div className="fixed inset-0 flex items-center justify-center z-50 bg-black bg-opacity-50">
          <div className="bg-white rounded-lg shadow-lg max-w-md w-full p-6">
            <div className="flex items-center mb-4">
              <FaExclamationTriangle className="text-yellow-500 text-2xl mr-2" />
              <h2 className="text-lg font-semibold">Alert</h2>
            </div>
            <div className="mb-4">
              <p>{errMessage}</p>
            </div>
            <div className="flex justify-end">
              <button
                onClick={() => setAlertPopup(false)}
                className="bg-blue-500 text-white rounded px-4 py-2 hover:bg-blue-600 transition"
              >
                Close
              </button>
            </div>
          </div>
        </div>
        </Popup>
    
      ) : null}
    </>
  );
};

export default AlertPopup;